export default __webpack_public_path__ + "static/media/sroki.234dfb29.pdf";